import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLanguage } from '../redux/cartSlice';
import { translations } from '../utils/translations';
import { trackEvent } from '../utils/analytics';
import './NewsletterSignup.css';

const NewsletterSignup = ({ source = 'footer' }) => {
  const selectedLang = useSelector(selectLanguage) || { code: 'en' };
  const t = translations[selectedLang.code || 'en'] || translations.en;
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('');
    try {
      const res = await fetch('/api/newsletter/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source }),
      });
      if (res.ok) {
        trackEvent('newsletter_signup', { source });
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="newsletter-signup">
      <h4>{t.newsletter || 'Newsletter'}</h4>
      <p>{t.subscribeDesc || 'Subscribe for deals and updates'}</p>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder={t.emailAddress || 'Your email'}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" data-track="button_click" data-track-label="newsletter_submit">
          {t.subscribe || 'Subscribe'}
        </button>
      </form>
      {status === 'success' && <p className="newsletter-msg success">{t.subscribed || 'Subscribed!'}</p>}
      {status === 'error' && <p className="newsletter-msg error">{t.pleaseTryAgain || 'Please try again.'}</p>}
    </div>
  );
};

export default NewsletterSignup;
